// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"276":"9ec83374","807":"fc852f4c"}[chunkId] + ".chunk.css";
};